import React from "react";
import {Redirect} from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "src/hooks/useAuth";
import {URL_TEMPLATES as URL} from "src/urlTemplates";

const UserGuard = ({children}) => {
    const {hasAdminRole, hasUserRole} = useAuth();

    if (!hasUserRole() && !hasAdminRole()) {
        return <Redirect to={URL._404}/>;
    }

    return <>{children}</>;
};

UserGuard.propTypes = {
    children: PropTypes.node
};

export default UserGuard;
